import { render, staticRenderFns } from "./dashboard-rank.vue?vue&type=template&id=7454f734&scoped=true&"
import script from "./dashboard-rank.vue?vue&type=script&lang=ts&"
export * from "./dashboard-rank.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard-rank.vue?vue&type=style&index=0&id=7454f734&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7454f734",
  null
  
)

export default component.exports